import React from "react";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";
import FormField from "@cloudscape-design/components/form-field";
import Select from "@cloudscape-design/components/select";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { tgBotsEditModalStore } from "../stores/tgBotsEditModal";
import { userStore } from "../stores/access";

class TgBotsEditModal extends React.Component {
	canEditToken = () => (this.props.user.level >= 6  || this.props.user.showColumn.includes("showTgToken"));

	resetModal = () => {
		this.props.setTgBotsEditModal({
			...this.props.tgBotsEditModal,
			show: false,
			loaded: true,
			id: 0,
			status: this.props.tgBotsEditModal.currentOption.status[0],
			bot_link: "",
			priority: "",
			token: "",
		});
	};

	editTgBot = () => {
		const { tgBotsEditModal } = this.props;
		const botLink = tgBotsEditModal.bot_link.trim();
		const priority = Number(tgBotsEditModal.priority);

		if (!botLink) {
			this.props.Interface.addNoty("Error", "Bot link is required");
			return;
		}

		if (tgBotsEditModal.priority === "" || Number.isNaN(priority)) {
			this.props.Interface.addNoty("Error", "Priority is required");
			return;
		}

		if (!tgBotsEditModal.status?.value) {
			this.props.Interface.addNoty("Error", "Status is required");
			return;
		}

		const payload = {
			id: tgBotsEditModal.id,
			bot_link: botLink,
			status: tgBotsEditModal.status.value,
			priority,
		};

		if (this.canEditToken()) {
			const token = tgBotsEditModal.token.trim();
			if (!token) {
				this.props.Interface.addNoty("Error", "Token is required");
				return;
			}
			payload.token = token;
		}

		this.props.setTgBotsEditModal({ ...tgBotsEditModal, loaded: false });
		this.props.Interface.request("set", { class: "data", module: "telegramBots", method: "edit" }, payload)
			.then(() => {
				this.props.Interface.addNoty("Success", "Telegram bot was successfully edited");
				this.resetModal();
				this.props.Interface.loadTgBotsList();
				this.props.Interface.loadTgBotsRotation();
			})
			.catch((error) => {
				this.props.Interface.addNoty("Error", error?.text || error?.toString?.() || "Request failed");
				this.props.setTgBotsEditModal({ ...tgBotsEditModal, loaded: true });
			});
	};

	render() {
		const { tgBotsEditModal } = this.props;
		const canEditToken = this.canEditToken();

		return (
			<Modal
				visible={tgBotsEditModal.show}
				onDismiss={this.resetModal}
				header="Edit Telegram bot"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button variant="normal" onClick={this.resetModal}>
								Close
							</Button>
							<Button variant="primary" onClick={this.editTgBot} loading={!tgBotsEditModal.loaded}>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				{tgBotsEditModal.loaded ? (
					<SpaceBetween direction="vertical" size="m">
						<FormField label="Bot link" stretch>
							<Input
								autoFocus
								inputMode="url"
								autoComplete="off"
								placeholder="Enter bot link"
								value={tgBotsEditModal.bot_link}
								onChange={({ detail }) => this.props.setTgBotsEditModal({ ...tgBotsEditModal, bot_link: detail.value })}
							/>
						</FormField>
						<FormField label="Priority" stretch>
							<Input
								type="number"
								placeholder="Enter priority"
								value={tgBotsEditModal.priority}
								onChange={({ detail }) => this.props.setTgBotsEditModal({ ...tgBotsEditModal, priority: detail.value })}
							/>
						</FormField>
						<FormField label="Status" stretch>
							<Select
								selectedOption={tgBotsEditModal.status}
								options={tgBotsEditModal.currentOption.status}
								placeholder="Select status"
								onChange={({ detail }) => this.props.setTgBotsEditModal({ ...tgBotsEditModal, status: detail.selectedOption })}
							/>
						</FormField>
						{canEditToken ? (
							<FormField label="Token" stretch>
								<Input
									autoComplete="off"
									placeholder="Enter token"
									value={tgBotsEditModal.token}
									onChange={({ detail }) => this.props.setTgBotsEditModal({ ...tgBotsEditModal, token: detail.value })}
								/>
							</FormField>
						) : null}
					</SpaceBetween>
				) : (
					<Box textAlign="center">
						<Spinner size="large" />
					</Box>
				)}
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const tgBotsEditModal = useRecoilValue(tgBotsEditModalStore);
		const setTgBotsEditModal = useSetRecoilState(tgBotsEditModalStore);
		const user = useRecoilValue(userStore);

		return <Component {...props} tgBotsEditModal={tgBotsEditModal} setTgBotsEditModal={setTgBotsEditModal} user={user} />;
	};
}

export default withRecoil(TgBotsEditModal);
